import React from 'react'

export default function VisiGiftChatHistory() {
  return (
    <div>VisiGiftChatHistory</div>
  )
}
